/**
 * MIME types that should be treated as text files for preview generation.
 * Includes plain text, code files, markup, and structured data formats.
 */
const TEXT_MIME_TYPES = [
	'text/', // Covers text/plain, text/markdown, text/csv, text/xml, etc.
	'application/json',
	'application/xml',
	'application/x-yaml',
	'application/javascript',
	'application/typescript',
	'application/x-sh',
];

/**
 * File extensions that should be treated as text files.
 * Used as fallback when MIME type is not recognized by the browser.
 */
const TEXT_EXTENSIONS = [
	'.txt',
	'.md',
	'.markdown',
	'.json',
	'.xml',
	'.yaml',
	'.yml',
	'.js',
	'.jsx',
	'.ts',
	'.tsx',
	'.css',
	'.scss',
	'.less',
	'.html',
	'.htm',
	'.csv',
	'.log',
	'.sh',
	'.bash',
	'.py',
	'.rb',
	'.java',
	'.c',
	'.cpp',
	'.h',
	'.go',
	'.rs',
	'.sql',
];

/**
 * Check if a file is a text-based file that can be previewed.
 * @param mimeType - The MIME type of the file
 * @param fileName - Optional file name for extension-based fallback
 */
export function isTextFile(mimeType: string, fileName?: string): boolean {
	// First check MIME type
	if (mimeType && TEXT_MIME_TYPES.some((type) => mimeType.startsWith(type))) {
		return true;
	}

	// Fallback to extension check if MIME type is empty or unrecognized
	if (fileName) {
		const lowerFileName = fileName.toLowerCase();
		return TEXT_EXTENSIONS.some((ext) => lowerFileName.endsWith(ext));
	}

	return false;
}
